module.exports = __webpack_public_path__ + "images/playlist_1080.e0acb9f00c765ea0b519e95325c98d19.png";